import { render, staticRenderFns } from "./StudentPosterLoader.vue?vue&type=template&id=3bb9e60b&scoped=true&"
import script from "./StudentPosterLoader.vue?vue&type=script&lang=js&"
export * from "./StudentPosterLoader.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterLoader.vue?vue&type=style&index=0&id=3bb9e60b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb9e60b",
  null
  
)

export default component.exports